import { Star, MapPin, ExternalLink } from "lucide-react";

const REVIEW_URL = "https://maps.app.goo.gl/mgKj8EAaMshWkTss5";
const MAP_EMBED = "https://www.google.com/maps?q=Ba%C4%9Fl%C4%B1ca%20Bulvar%C4%B1%20Mert%20Caddesi%20No%3A4%2F2%20Etimesgut%20Ankara&output=embed";

function GoogleG({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-label="Google">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34.2 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34.2 6.1 29.4 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 44c5.3 0 10.1-2 13.7-5.3l-6.3-5.2c-2 1.5-4.6 2.5-7.4 2.5-5.2 0-9.6-3.3-11.2-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.7l6.3 5.2C41.6 35 44 30 44 24c0-1.3-.1-2.3-.4-3.5z"/>
    </svg>
  );
}

function StarRow({ value = 5, size = 18 }) {
  return (
    <div className="flex items-center gap-0.5" aria-label={`${value} yıldız`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          size={size}
          className={i < value ? "text-[#F5B301] fill-[#F5B301]" : "text-[#E5EAF0] fill-[#E5EAF0]"}
        />
      ))}
    </div>
  );
}

const TESTIMONIALS = [
  {
    name: "Ayşe K.",
    text: "Kliniğin hijyeni ve uzman kadrosu gerçekten çok iyi. Hydrafacial sonrası cildim yenilendi, ekibe teşekkürler.",
  },
  {
    name: "Mehmet T.",
    text: "Batık tırnak sorunum için gittim, Serdar Bey son derece profesyonel. Ağrısız ve hızlı çözüm sağladı.",
  },
  {
    name: "Selin D.",
    text: "Lazer epilasyon seanslarımdan çok memnunum. Ekip çok ilgili, salon tertemiz. Bağlıca'nın en iyisi.",
  },
];

export default function GoogleReviews() {
  return (
    <section data-testid="google-reviews" className="py-20 md:py-28 bg-[#F5F7FA] border-y border-[#E5EAF0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 items-stretch">
          {/* Reviews summary + testimonials */}
          <div className="flex flex-col">
            <div className="bg-white border border-[#E5EAF0] rounded-3xl p-8 md:p-10 shadow-sm">
              <div className="flex items-center gap-4 mb-6">
                <div className="h-14 w-14 rounded-2xl bg-white border border-[#E5EAF0] flex items-center justify-center shadow-sm">
                  <GoogleG size={28} />
                </div>
                <div>
                  <p className="text-[11px] tracking-[0.2em] uppercase text-[#7C8CA0] font-semibold">Google İşletme</p>
                  <p className="font-display text-2xl md:text-3xl text-[#0B1B33] font-medium">MediEste Yorumları</p>
                </div>
              </div>
              <div className="flex flex-wrap items-baseline gap-x-4 gap-y-2 mb-4">
                <span className="font-display text-6xl md:text-7xl text-[#0B1B33] font-medium tracking-tight">5,0</span>
                <div>
                  <StarRow value={5} size={22} />
                  <p className="text-sm text-[#4B5A6E] mt-1"><strong className="text-[#0B1B33]">280+</strong> Google değerlendirmesi</p>
                </div>
              </div>
              <a
                href={REVIEW_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="google-reviews-cta"
                className="mt-4 inline-flex items-center gap-2 h-12 px-6 rounded-full bg-[#0E2B4F] text-white text-xs tracking-[0.15em] uppercase font-semibold hover:bg-[#143a68] transition-colors"
              >
                Yorumları İncele <ExternalLink size={13} />
              </a>
            </div>

            <div className="mt-6 grid gap-4">
              {TESTIMONIALS.map((t, i) => (
                <blockquote key={i} className="bg-white border border-[#E5EAF0] rounded-2xl p-5 md:p-6">
                  <StarRow value={5} size={14} />
                  <p className="text-[#0B1B33] text-sm md:text-base leading-relaxed mt-3 mb-3">"{t.text}"</p>
                  <footer className="flex items-center justify-between">
                    <span className="text-xs font-semibold text-[#0B1B33]">{t.name}</span>
                    <span className="text-[10px] tracking-[0.2em] uppercase text-[#7C8CA0] flex items-center gap-1">
                      <GoogleG size={12} /> Google
                    </span>
                  </footer>
                </blockquote>
              ))}
            </div>
          </div>

          {/* Google Maps embed */}
          <div className="flex flex-col">
            <div className="bg-white border border-[#E5EAF0] rounded-3xl overflow-hidden shadow-sm flex flex-col flex-1">
              <div className="p-6 border-b border-[#E5EAF0] flex items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-xl bg-[#10B981]/10 text-[#10B981] flex items-center justify-center shrink-0">
                    <MapPin size={20} />
                  </div>
                  <div>
                    <p className="text-[11px] tracking-[0.2em] uppercase text-[#7C8CA0] font-semibold">Konum</p>
                    <p className="font-display text-lg text-[#0B1B33] font-medium leading-snug">Bağlıca / Etimesgut, Ankara</p>
                  </div>
                </div>
                <a
                  href={REVIEW_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="hidden sm:inline-flex items-center gap-1 text-xs tracking-[0.15em] uppercase text-[#10B981] font-semibold uline-link"
                >
                  Yol Tarifi →
                </a>
              </div>
              <iframe
                title="MediEste Google Haritalar"
                src={MAP_EMBED}
                className="w-full flex-1 min-h-[380px]"
                loading="lazy"
                style={{ border: 0 }}
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
